<template>
  <button
    v-if="productCount > maxProductsToShow"
    class="collection__load-more btn btn--black"
    @click="loadMore"
  >
    Load more
  </button>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useCollectionStore } from '../pinia/CollectionStore'

export default {
  computed: {
    ...mapState (useCollectionStore, [
      'pagination',
      'productCount'
    ]),
    maxProductsToShow () {
      return this.pagination.page_size * this.pagination.current_page
    }
  },
  methods: {
    ...mapActions (useCollectionStore, [
      'loadMore'
    ]),
  }
}
</script>
